import React, { useEffect } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { TextField, Select } from 'final-form-material-ui';
import {
  TextField as MuiTextField,
  MenuItem,
  Button,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
  getFilters,
  getUsers,
} from '../../../state/reducers/ApplicationReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';
import AppConfigs from '../../../conf';
import { toActiveLocale } from '../../../services/Translation';

export function DateRangeInput(props) {
  let { input, classes } = props;
  let { t } = useTranslation();
  let [from, to = ''] = input.value.split(' ');

  let onFromChange = (value) => {
    input.onChange(`${value} ${to}`);
  };
  let onToChange = (value) => {
    input.onChange(`${from} ${value}`);
  };
  return (
    <div className={classes.dateInput}>
      <DateInput
        label={t('filter.submittedDateFrom')}
        input={{
          ...input,
          value: from,
          onChange: onFromChange,
        }}
      />
      <span className={classes.delimeter}> - </span>
      <DateInput
        label={t('filter.submittedDateTo')}
        input={{
          ...input,
          value: to,
          onChange: onToChange,
        }}
      />
    </div>
  );
}

function DateInput(props) {
  let { className, input, label } = props;
  function onChange(e) {
    input.onChange(e.target.value);
  }
  return (
    <MuiTextField
      {...input}
      className={className}
      type="date"
      margin="none"
      label={label}
      InputLabelProps={{
        shrink: true,
      }}
      value={input.value}
      onChange={onChange}
    />
  );
}

function CheckBox(props) {
  let { label, input } = props;
  return (
    <FormControlLabel
      control={<Checkbox {...input} color="primary" />}
      label={label}
    />
  );
}

function ApplicationsFilter(props) {
  let { filters, setFilters, getUsers, users, classes } = props;
  let { t } = useTranslation();
  useEffect(() => {
    getUsers();
  }, [getUsers]);

  function onSubmit(values) {
    setFilters(values);
  }

  return (
    <Form initialValues={filters} onSubmit={onSubmit}>
      {({ handleSubmit, form }) => (
        <div className={classes.container}>
          <form className={classes.form}>
            <Field
              name="shortCode"
              label={t('filter.shortCode')}
              component={TextField}
              className={classes.field}
            />
            <Field
              name="nameLast"
              label={t('filter.lastName')}
              component={TextField}
              className={classes.field}
            />
            <Field
              name="status"
              label={t('filter.status')}
              component={Select}
              className={classes.field}
            >
              <MenuItem value={''} key="null" />
              {Object.values(AppConfigs.applicationStatuses).map(
                ({ uuid, ...rest }) => (
                  <MenuItem key={uuid} value={uuid}>
                    {toActiveLocale(rest)}
                  </MenuItem>
                )
              )}
            </Field>
            <Field
              name="submittedAt"
              component={DateRangeInput}
              className={classes.field}
              classes={classes}
            />
            <Field
              name="createdByAssignmentId"
              label={t('filter.submitter')}
              component={Select}
              className={cn(classes.field, classes.select)}
            >
              <MenuItem value={''}></MenuItem>
              {users.map(({ uuid, nameLast, nameFirst }) => (
                <MenuItem
                  key={uuid}
                  value={uuid}
                >{`${nameLast} ${nameFirst}`}</MenuItem>
              ))}
            </Field>
            <Field
              name="isMarkedForLocalPayment"
              type="checkbox"
              label={t('filter.visaForLocalPayment')}
              component={CheckBox}
            />
          </form>
          <div className={classes.buttonGroup}>
            <Button
              variant="contained"
              color="default"
              className={classes.btn}
              onClick={() => {
                setFilters({});
                form.reset();
              }}
            >
              {t('clear')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.btn}
              onClick={handleSubmit}
            >
              {t('apply')}
            </Button>
          </div>
        </div>
      )}
    </Form>
  );
}

const styles = (theme) => ({
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
  },
  field: {
    marginRight: '20px',
    minWidth: '100px',
  },
  container: {
    display: 'flex',
    margin: '32px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  btn: {
    marginRight: '10px',
  },
  dateInput: {
    marginRight: '20px',
    display: 'inline-flex',
    alignItems: 'center',
  },
  delimeter: {
    margin: '0 8px',
  },
  select: {
    textAlign: 'left',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default compose(
  connect(
    (state) => ({
      filters: getFilters(state),
      users: getUsers(state),
    }),
    {
      setFilters: ApplicationActions.setFilters,
      getUsers: ApplicationActions.getUsers,
    }
  ),
  withStyles(styles)
)(ApplicationsFilter);



// WEBPACK FOOTER //
// ./src/view/scenes/Applications/ApplicationsFilter.js